import React, { useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import AnimatedLayer from './components/AnimatedLayer';
import useResize from 'src/shared/hooks/useResize';
import MarketingSection from 'src/components/MarketingSection';

interface Props {
    onFocus: (key: string) => void;
}

const OfferingStackSection = (props: Props) => {
    const { isDesktop } = useResize();

    const timer = useRef<any>();

    const onHoverStart = (key: string) => {
        clearTimeout(timer.current);
        props.onFocus(key);
    };

    const onHoverEnd = () => {
        timer.current = setTimeout(() => props.onFocus(''));
    };

    useEffect(() => {
        if (!isDesktop) {
            props.onFocus('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDesktop]);

    return (
        <MarketingSection>
            <div className={styles.container}>
                <div className={styles.layers}>
                    {isDesktop && (
                        <>
                            <AnimatedLayer
                                src="/static/images/svg/offerings/img_layer1_fill@4x.svg"
                                iconSrc="/static/images/svg/offerings/ico_layer1@4x.svg"
                                isFirst
                                onHoverStart={() => onHoverStart('01')}
                                onHoverEnd={onHoverEnd}
                            />
                            <AnimatedLayer
                                src="/static/images/svg/offerings/img_layer2_fill@4x.svg"
                                iconSrc="/static/images/svg/offerings/ico_layer2@4x.svg"
                                onHoverStart={() => onHoverStart('02')}
                                onHoverEnd={onHoverEnd}
                            />
                            <AnimatedLayer
                                src="/static/images/svg/offerings/img_layer3_fill@4x.svg"
                                iconSrc="/static/images/svg/offerings/ico_layer3@4x.svg"
                                onHoverStart={() => onHoverStart('03')}
                                onHoverEnd={onHoverEnd}
                            />
                            <AnimatedLayer
                                src="/static/images/svg/offerings/img_layer4_fill@4x.svg"
                                iconSrc="/static/images/svg/offerings/ico_layer4@4x.svg"
                                onHoverStart={() => onHoverStart('04')}
                                onHoverEnd={onHoverEnd}
                            />
                        </>
                    )}
                    {!isDesktop && (
                        <>
                            <img className={styles.static} src="/static/images/svg/offerings/img_layer1.svg" />
                            <img className={styles.static} src="/static/images/svg/offerings/img_layer2.svg" />
                            <img className={styles.static} src="/static/images/svg/offerings/img_layer3.svg" />
                            <img className={styles.static} src="/static/images/svg/offerings/img_layer4.svg" />
                        </>
                    )}
                </div>
            </div>
        </MarketingSection>
    );
};

export default OfferingStackSection;
